<!-- <button mat-button [routerLink]="'/rent'">
    Accueil 
</button>

<button mat-button [routerLink]="'/rent/search'">
    Rechercher 
</button>

<button mat-button [routerLink]="'/rent/booking'">
    Reserver 
</button> -->
<!-- 
<button mat-button [routerLink]="'/rent/details'">
    Details 
</button>

<button mat-button [routerLink]="'/rent/fleet'">
    Flotte 
</button> -->

<router-outlet></router-outlet>